import { Login } from '@services/api'
import IntlCommon from '@stores/IntlCommon'

export const DEV_CAPTCHA_SERVER = {
  api_server: 'https://captcha-api-stg.pingan.com:10530',
  static_servers: ['captcha-static-stg.pingan.com'],
}

export const CAPTCHA_SERVER = {
  api_server: 'https://captcha-api.pingan.com',
  static_servers: ['captcha-static.pingan.com'],
}

/**
 * 初始化验证码，获取验证码对象，
 * @param {*} handler 回调函数
 */
export const initCaptcha = async (type: number, handler: any) => {
  return new Promise(async (resolve) => {
    try {
      const res = await Login.getCaptchaGt(type)
      const data = res.body || res.data
      // const server =
      //   location.hostname.includes('test') ||
      //   location.hostname.includes('localhost')
      //     ? DEV_CAPTCHA_SERVER
      //     : CAPTCHA_SERVER
      // 100 是和后端约定的值，表示科技滑块验证服务暂不可用
      if (!data || +res.body.code === 100) {
        resolve(false)
        return
      }

      resolve(true)
      const { gt, challenge, apiServer, staticServer } = data
      // 获取语言类型
      const lang = () => {
        const { browserLanguage } = IntlCommon
        if (browserLanguage === 'zh') return 'zh-cn' // 中文
        if (browserLanguage === 'tw') return 'zh-tw' // 繁体
        if (browserLanguage === 'en') return 'en'    // 英文
        return 'zh-cn'
      }
      // @ts-ignore
      initGeetest(
        {
          gt,
          challenge,
          api_server: apiServer,
          static_servers: [staticServer],
          offline: false,
          product: 'custom',
          new_captcha: true,
          https: true,
          width: '100%',
          area: '#captcha-pupup', // 必填参数
          next_width: '300px',
          bg_color: 'white',
          lang: lang() // 滑块验证语言
        },
        handler
      )
    } catch(e) {
      console.warn('Get captcha failed, info:', e)
    }
  })
}

export const isCaptchaPopupShow = () => {
  const popup = document.querySelector('.geetest_popup')
  if (!popup) {
    return false
  }
  return window.getComputedStyle(popup).display === 'block'
}

export const hideGeetestPopup = (captcha: any, targetEl: any) => {
  const popup = document.querySelector('.geetest_popup')
  if (isCaptchaPopupShow() && captcha && !popup?.contains(targetEl)) {
    captcha.hide()
  }
}
